module.exports = __webpack_public_path__ + "img/sign-hanging.9bbc36ba.svg";